var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.377 13.9019C26.377 20.0406 21.1474 25.1675 14.5067 25.1675C7.86601 25.1675 2.63647 20.0406 2.63647 13.9019C2.63647 7.7632 7.86601 2.63636 14.5067 2.63636C21.1474 2.63636 26.377 7.7632 26.377 13.9019ZM22.986 24.4008C20.6415 26.1353 17.7001 27.1675 14.5067 27.1675C6.8464 27.1675 0.636475 21.2283 0.636475 13.9019C0.636475 6.57555 6.8464 0.63636 14.5067 0.63636C22.1671 0.63636 28.377 6.57555 28.377 13.9019C28.377 17.4703 26.9038 20.7096 24.5074 23.0939L32.7871 31.3735L31.3729 32.7878L22.986 24.4008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f116412cd3c6866cc74d7da6077d5a75.svg";
export { ForwardRef as ReactComponent };